// lint-internal-leaks-ignore-next-line: framework-script — load-bearing visual regression marker
// @visual-diff-render: vite
/**
 * @file Checkbox — a styled wrapper around MUI's Checkbox
 * @version 0.1.0
 */

import React, { forwardRef } from 'react';
import MuiCheckbox, { type CheckboxProps as MuiCheckboxProps } from '@mui/material/Checkbox';

/**
 * Heidrick Checkbox — a styled wrapper around MUI's Checkbox.
 *
 * Visual styling is applied via `heidrickTheme.components.MuiCheckbox` —
 * wrap your app in `<ThemeProvider theme={heidrickTheme}>` for the Heidrick
 * checked-state glyph and state treatments (default / hover / focus /
 * disabled / error × off / on) to apply.
 *
 * The Heidrick-only `error` prop is added to MUI's CheckboxProps via
 * TypeScript module augmentation. The custom checked-state glyph
 * (CheckboxIcon) is wired into MUI Checkbox by the theme's `checkedIcon`
 * default — not something consumers need to apply manually.
 *
 * @example
 * <Checkbox defaultChecked />
 * <Checkbox error />
 * <Checkbox disabled />
 */
export const Checkbox = forwardRef<HTMLButtonElement, CheckboxProps>(
  function Checkbox(props, ref) {
    return <MuiCheckbox ref={ref} {...props} />;
  },
);

export type CheckboxProps = MuiCheckboxProps;
